<template>
  <div class="no-paragraph-editor">
    <TiptapWrap
      ref="tiptapWrap"
      v-bind="{ ...$props, ...$attrs }"
      :value="noParagraphValue"
      @update:model-value="onUpdateModalValue"
      @link-edit="$emit('linkEdit', $event)"
      @show-apply-template="$emit('showApplyTemplate', $event)"
      @ai-suggest-click="$emit('aiSuggestClick', $event)"
      @add-editor="$emit('addEditor', $event)"
      @blur-editor="$emit('blurEditor', $event)"
      @remove-editor="$emit('removeEditor', $event)"
      @update-selected-json="$emit('updateSelectedJson', $event)"
      @focus-editor="$emit('focusEditor', $event)"
    />
  </div>
</template>

<script>
import { generateHTML } from '@tiptap/html';
import TiptapWrap from '@ui/components/editor/TiptapWrap/TiptapWrap.vue';
import { tiptapWrapProps } from '@ui/components/editor/TiptapWrap/tiptapWrapProps';
import { extensions } from '@ui/components/editor/TiptapWrap/extensions';
import { replaceParagraphHtml, replaceParagraphJson } from './replaceParagraph';

export default {
  name: 'NoParagraphEditor',
  components: { TiptapWrap },

  props: {
    ...tiptapWrapProps,
  },
  emits: [
    'update:modelValue',
    'linkEdit',
    'showApplyTemplate',
    'aiSuggestClick',
    'addEditor',
    'blurEditor',
    'removeEditor',
    'updateSelectedJson',
    'focusEditor',
  ],

  data() {
    return {
      noParagraphValue: '',
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.noParagraphValue = replaceParagraphHtml(value);
      },
    },
  },

  methods: {
    onUpdateModalValue(event) {
      const json = { ...event.json, content: replaceParagraphJson(event.json.content) };
      const html = generateHTML(json, extensions({
        getTiptapWrap: () => this.$refs.tiptapWrap,
        disabledNodes: this.disabledNodes,
      }));
      // pass updated value down to TiptapWrap
      this.noParagraphValue = html;

      // emit updated event up to parent
      this.$emit('update:modelValue', { ...event, json, html });
    },
  },
};
</script>
